/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationDetails
 */
export interface OrganizationDetails {
    /**
     * 
     * @type {number}
     * @memberof OrganizationDetails
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetails
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationDetails
     */
    isPublic: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrganizationDetails
     */
    programPriceAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetails
     */
    programPriceCurrency?: string;
}

export function OrganizationDetailsFromJSON(json: any): OrganizationDetails {
    return OrganizationDetailsFromJSONTyped(json, false);
}

export function OrganizationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isPublic': json['is-public'],
        'programPriceAmount': !exists(json, 'program-price-amount') ? undefined : json['program-price-amount'],
        'programPriceCurrency': !exists(json, 'program-price-currency') ? undefined : json['program-price-currency'],
    };
}

export function OrganizationDetailsToJSON(value?: OrganizationDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'is-public': value.isPublic,
        'program-price-amount': value.programPriceAmount,
        'program-price-currency': value.programPriceCurrency,
    };
}


